import React, { Component, PropTypes } from 'react'

import api from '../../api'
import { AutoComplete } from 'material-ui'

class DiscountSelector extends Component<any, any> {
  state = {
    discounts: null
  }

  componentWillMount () {
    if (this.props.resource.reservation_product_id) {
      this.getDiscounts()
    }
  }

  componentDidUpdate (newProps) {
    if (newProps.resource.reservation_product_id !== this.props.resource.reservation_product_id) {
      this.getDiscounts()
    }
  }

  getDiscounts () {
    api.get('admin/discounts', { body: this.createQueryBody() })
      .then(res => res.json())
      .then(discounts => {
        this.setState({ discounts })
      })
  }

  createQueryBody () {
    const productId = this.props.resource.reservation_product_id
    const body = {
      filters: {
        product_id_in: productId
      }
    }

    return body
  }

  render () {
    const { discounts } = this.state
    const { value, onChange } = this.props

    if (discounts === null) {
      return <div />
    }

    return (
      <div>
        <AutoComplete
          errorText={this.props.errorText}
          filter={AutoComplete.caseInsensitiveFilter}
          floatingLabelText={`Discount ${value ? '#' + value : ''}`}
          dataSource={discounts.map((discount) => ({
            text: discount.code,
            value: discount.id
          }))}
          dataSourceConfig={{ text: 'text', value: 'value' }}
          onNewRequest={(e, discountIndex) => {
            onChange(e, discounts[discountIndex].id)
          }}

        />
      </div>
    )
  }
}

// @ts-ignore
DiscountSelector.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  errorText: PropTypes.string
}

// @ts-ignore
DiscountSelector.defaultProps = {
  errorText: null
}

export default DiscountSelector
